import { useEffect, useState } from 'react';
// import { initMercadoPago } from '@mercadopago/sdk-react';

import { Payment } from '@mercadopago/sdk-react';
import { Box, Container, Typography, Paper, Button, Divider, Snackbar, Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import ContactInfo from './ContactInfo';
import { auth } from '../utils/auth';
import instance from '../utils/axiosConfig';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const PaymentForm = ({ price, selectedPlan, verify }) => {
  // Comment out MP initialization
  // initMercadoPago('APP_USR-35cb45bf-3fe2-443c-92f7-7982fa47fea1', {locale: 'es'});
  const navigate = useNavigate();

  // Comment out MP initialization object
  /*
  const initialization = {
    amount: price,
    preferenceId: "<PREFERENCE_ID>",
    payer: {
        email: auth.getUser()?.email || ''
    },
  };

  const customization = {
    paymentMethods: {
      creditCard: "all",
      debitCard: "all",
      wallet: "all",
    },
  };
  */

  // Comment out MP handlers
  /*
  const handleCardResponse = async (cardData) => {
    try {
      console.log('Card token received:', cardData);

      const subscriptionResponse = await instance.post('/api/mp/create-subscription', {
        cardTokenId: cardData.token,
        email: auth.getUser().email,
        distributorId: auth.getUser()._id,
        planId: selectedPlan.title.toLowerCase(),
        preapprovalPlanId: selectedPlan.mpPlanId,
        reason: `Suscripción Plan ${selectedPlan.title}`
      });

      const result = await subscriptionResponse.data;
      
      if (result.success) {
        navigate('/subscription/success');
      } else {
        console.error('Subscription creation failed:', result.error);
      }
    } catch (error) {
      console.error('Error creating subscription:', error);
    }
  };

  const onSubmit = async ({ selectedPaymentMethod, formData }) => {
    try {
      if (formData) {
        await handleCardResponse(formData);
      }
    } catch (error) {
      console.error('Error in payment submission:', error);
    }
  };

  const onError = async (error) => {
    console.log(error);
  };

  const onReady = async () => {
  };
  */

  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedMonths, setSelectedMonths] = useState(1);

  const handleFileChange = (event) => {
    if (event.target.files[0]) {
      setSelectedFile(event.target.files[0]);
    }
  };

  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

  const [successDialog, setSuccessDialog] = useState(false);

  // Add discount calculation helper
  const calculateDiscountedPrice = (basePrice, months) => {
    if (months <= 1) return basePrice;
    
    // 2% discount per extra month (months - 1 because first month has no discount)
    const discountPercent = (months - 1) * 2;
    const discountMultiplier = (100 - discountPercent) / 100;
    
    return basePrice * months * discountMultiplier;
  };

  const handleSubmit = async () => {
    if (!selectedFile) {
        alert('Por favor seleccione un archivo');
        return;
    }

    try {
        const formData = new FormData();
        formData.append('invoice', selectedFile);
        formData.append('planAmount', Math.round(calculateDiscountedPrice(price, selectedMonths)));
        formData.append('planId', selectedPlan._id);
        formData.append('planMonths', selectedMonths);

        const response = await instance.post('/api/invoices', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (response.data.success) {
            setSuccessDialog(true);
            setSelectedFile(null);
        } else {
            alert(response.data.error || 'Error al subir el comprobante');
        }
    } catch (error) {
        console.error('Error uploading invoice:', error);
        alert(error.response?.data?.error || 'Error al subir el comprobante');
    }
  };

  return (
    <Container
      sx={{
        display: 'flex',
        justifyContent: 'start',
        flexDirection: 'column',
        alignItems: 'center',
        height: 'auto',
        paddingTop: '2rem',
        backgroundColor: '#f1f1f1',
        px: { xs: 1, sm: 2, md: 3 },
        py: { xs: 4},
        pb: { xs: 10}
      }}
    >
      <Paper
        elevation={1}
        sx={{
          width: { xs: '95%', sm: '90%', md: '50vw' },
          padding: { xs: '15px', sm: '20px' },
          marginBottom: '20px',
          backgroundColor: 'white',
          borderLeft: '4px solid #FF8C00'
        }}
      >
        <Typography variant="h6" gutterBottom>
          Resumen de compra
        </Typography>
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: { xs: 'flex-start', sm: 'center' },
          flexDirection: { xs: 'column', sm: 'row' } 
        }}>
          <Typography variant="body1" sx={{ mb: { xs: 1, sm: 0 } }}>
            Plan {selectedPlan?.title} x {selectedMonths} {selectedMonths === 1 ? 'mes' : 'meses'}
            {selectedMonths > 1 && (
              <Typography 
                component="span" 
                color="success.main" 
                sx={{ display: 'block', fontSize: '0.9em' }}
              >
                {(selectedMonths - 1) * 2}% de descuento aplicado
              </Typography>
            )}
          </Typography>
          <Box sx={{ textAlign: { xs: 'left', sm: 'right' } }}>
            {selectedMonths > 1 && (
              <Typography 
                variant="body2" 
                color="text.secondary" 
                sx={{ textDecoration: 'line-through' }}
              >
                ${price * selectedMonths}
              </Typography>
            )}
            <Typography 
              variant="h3" 
              sx={{ 
                fontWeight: 'bold', 
                color: selectedMonths > 1 ? 'success.main' : 'inherit',
                fontSize: { xs: '1.8rem', sm: '2.5rem' } 
              }}
            >
              ${Math.round(calculateDiscountedPrice(price, selectedMonths))}
            </Typography>
          </Box>
        </Box>
        {selectedPlan?.features && (
          selectedPlan.features.map((feature, index) => (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              {feature}
            </Typography>
          ))
        )}
        <Divider
        sx={{
          width: '100%',
          marginTop: '16px',
      }}
      >

      </Divider>
        <Typography variant="body2" color="green" sx={{ mt: 1 }}>
          {verify ?
           ('Nos contactaremos para realizar la verificación de confianza.' ) : ''}
          {verify ? (<br></br>) : ''}
          {verify ? ('El verificado y la medalla se otorgarán luego de coordinar la verificación.') : ''}
        </Typography>
        <Typography variant="body2" color="red" sx={{p: '0px'}} >
        {verify ? ('De no poder realizar / aprobar la verificación, se devolverá el dinero.') : ''}
        </Typography>
      </Paper>

      <Box 
        sx={{ 
          display: 'flex', 
          width: '90%',
          gap: 3,
          marginTop: 2,
          flexDirection: { xs: 'column', md: 'row' }
        }}
      >

        {/* Transfer Section */}
        <Paper
          elevation={2}
          sx={{
            flex: 1,
            backgroundColor: 'white',
            padding: { xs: '15px', sm: '18px' },
            height: 'fit-content',
            borderRadius: '10px',
            width: '100%',
            overflow: 'hidden'
          }}
        >
          <Typography variant="h5" sx={{ 
            fontSize: { xs: '16px', sm: '18px' }, 
            fontWeight: 'bold',
            mb: { xs: 1, sm: 2 }
          }}>
            Aboná una cantidad de meses fija vía transferencia bancaria adjuntando el comprobante de pago.
          </Typography>
          <Divider sx={{ width: '110%', marginTop: '16px', marginLeft: '-5%' }} />
          <Typography variant="body1" sx={{ fontSize: '16px', mt:1 }}>
            La acreditación del plan se realizará en el siguiente día hábil.
          </Typography>
          <Typography variant="body1" sx={{ fontSize: '16px', mt:1 }}>
            El monto a abonar equivale al valor del plan multiplicado por la cantidad de meses.
          </Typography>

          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" sx={{ fontSize: '16px', mb: 1 }}>
              Seleccionar cantidad de meses:
            </Typography>
            <TextField
              select
              value={selectedMonths}
              onChange={(e) => setSelectedMonths(Number(e.target.value))}
              fullWidth
              size="small"
            >
              {[1, 2, 3, 4, 5, 6, 12].map((month) => (
                <MenuItem key={month} value={month}>
                  {month} {month === 1 ? 'mes' : 'meses'}
                </MenuItem>
              ))}
            </TextField>
            <Typography variant="body1" sx={{ fontSize: '16px', mt:1 }}>
              CVU: 0000003100030433531640 | Alias: liderdist
            </Typography>
          </Box>

          <Paper
            elevation={0}
            sx={{
              border: '1px dashed #ccc',
              padding: '16px',
              marginTop: '16px',
              width: '100%',
              backgroundColor: '#f8f8f8',
              textAlign: 'center'
            }}
          >
            {selectedFile ? (
              <Typography sx={{ mb: 2, color: 'text.secondary' }}>
                Archivo seleccionado: {selectedFile.name}
              </Typography>
            ) : (
              <Typography sx={{ mb: 2, color: 'text.secondary' }}>
                Ningún archivo seleccionado
              </Typography>
            )}

            <Button
              component="label"
              startIcon={<CloudUploadIcon />}
              sx={{
                marginTop: '10px',
                marginBottom: '10px',
              }}
            >
              Agregar comprobante
              <VisuallyHiddenInput
                type="file"
                accept=".pdf,.png,.jpg,.jpeg"
                onChange={handleFileChange}
              />
            </Button>
          </Paper>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%'
            }}
          >
            <Button
              variant="contained"
              fullWidth
              onClick={handleSubmit}
              sx={{
                marginTop: '16px',
                backgroundColor: '#e88b00',
                '&:hover': {
                  backgroundColor: '#d47d00',
                },
                width: '40%'
              }}
            >
              Enviar comprobante
            </Button>
          </Box>
          <Divider
            sx={{
              width: '100%',
              marginTop: '16px',
            }}
          >

          </Divider>
          <Typography variant="body1" sx={{ fontSize: '16px', my:2 }}>
            También podés enviar el comprobante a cualquiera de nuestros canales de contacto y concretar la compra por esa vía.
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%'
            }}
          >
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
            <ContactInfo />
          </Box>
        </Paper>
        {/* MercadoPago Section */}
        {/*
        <Box sx={{ 
            flex: 1, 
            width: '100%',  
            backgroundColor: 'white',
            borderRadius: '10px',
            pt: 2,
            }}>
            <Typography variant="h5" sx={{ 
            fontSize: { xs: '16px', sm: '18px' }, 
            fontWeight: 'bold',
            textAlign: 'center',
            mb:0,
            pb:0,
          }}>
            Suscripción recurrente vía MercadoPago
          </Typography>
          <Divider sx={{ width: '100%', marginTop: '16px' }} />
          <Payment
            initialization={initialization}
            customization={customization}
            onSubmit={onSubmit}
            onReady={onReady}
            onError={onError}
          />
        </Box>
        */}
      </Box>

      <Dialog
        open={successDialog}
        onClose={() => setSuccessDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ 
          bgcolor: '#4CAF50', 
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
          <CheckCircleOutlineIcon /> Comprobante Enviado
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Typography variant="body1" gutterBottom>
            Comprobante enviado exitosamente. Dentro de las próximas 48 horas hábiles se efectivizará el plan.
          </Typography>
          {verify && (
            <Typography variant="body1" sx={{ mt: 2, color: 'primary.main' }}>
              En breve nos contactaremos para realizar la verificación de confianza.
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => {
              setSuccessDialog(false);
              navigate('/dashboard');
            }}
            variant="contained"
            color="primary"
          >
            Entendido
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default PaymentForm; 